import { useState, memo } from 'react'
import classnames from 'classnames'
import Logo from '../../logo'
import { ROUTES, zIndex } from '../../../constants'
import FlatX from '../../svg/flat-x'
import Hamburger from '../../svg/hamburger'
import Button from '../components/../../button/button'

const Header = memo(({ headerType, hideRegister, scrollToRegisterSectionOrModal }) => {
  const [open, setOpen] = useState(false)
  const [buttons, setButtons] = useState(true)

  return (
    <header className={classnames({ open })}>
      <div className='container flex justifyBetween alignCenter'>
        <div className='logoContainer'>
          <Logo />
        </div>
        <nav className='asideNavigation'>
          <ul className='flex justifyEnd alignCenter'>
            <li>
              {headerType === 'UA' ? (
                <a href='#Union_Benefits' className='link' onClick={() => setOpen(false)}>
                  <span>Benefits</span>
                </a>
              ) : (
                <a href='#Membership_Benefits' className='link' onClick={() => setOpen(false)}>
                  <span>Benefits</span>
                </a>
              )}
            </li>
            <li>
              <a
                href='#For_Members_and_Your_Families'
                className='link'
                onClick={() => setOpen(false)}
              >
                <span>About</span>
              </a>
            </li>
            <li>
              <a href='#Frequently_Asked_Questions' className='link' onClick={() => setOpen(false)}>
                <span>FAQs</span>
              </a>
            </li>
            <li style={{ display: `${hideRegister ? 'none' : ''}` }}>
              {!open && buttons ? (
                <Button color={headerType} onClick={scrollToRegisterSectionOrModal}>
                  Register
                </Button>
              ) : (
                <a className='link' onClick={scrollToRegisterSectionOrModal}>
                  Register
                </a>
              )}
            </li>
            <li>
              {!open && buttons ? (
                <Button color={'membership'}>
                  <a href={ROUTES.Search}>Find Vehicles</a>
                </Button>
              ) : (
                <a href={ROUTES.Search}>Find Vehicles</a>
              )}
            </li>
          </ul>
        </nav>
        <button
          aria-label={open ? 'close menu' : 'open menu'}
          className='flatBtn burgerBtn'
          onClick={() => {
            setOpen(!open)
            setButtons(open)
          }}
        >
          {open ? <FlatX /> : <Hamburger />}
        </button>
      </div>

      <style jsx>{`
        .UA {
          background-color: rgb(255, 69, 9) !important;
        }
        header {
          position: fixed;
          width: 100%;
          top: 0;
          height: 100vh;
          max-height: 8.5rem;
          background: #fff;
          transition: max-height 0.15s;
          box-shadow: 0 0.8rem 0.8rem rgba(0, 0, 0, 0.06);

          &.open {
            max-height: 100vh;

            .burgerBtn {
              width: 3.6rem;
              height: 3.6rem;
              margin: 0 0.4rem;
            }
          }
        }

        .burgerBtn {
          display: none;
          position: absolute;
          top: 0.9rem;
          right: 0.2rem;
          width: 4.2rem;
          height: 3.6rem;
          padding: 1rem;

          :global(svg) {
            width: 100%;
            height: 100%;
          }
        }

        .container {
          width: 100%;
          height: 100%;
          margin: 0 auto;
          padding: 0 4.2rem;
          max-width: 192rem;
        }

        .logoContainer {
          max-width: 21rem;
          width: 100%;
          margin-right: 5.6rem;
        }

        .mainNavigation {
          flex: 1;

          li:not(:last-child) {
            margin-right: 3rem;
          }

          a {
            font-weight: bold;
            font-size: 1.8rem;

            &.primary {
              font-weight: 700;
              color: var(--text-link-color);
            }
          }
        }

        .asideNavigation {
          li:not(:last-child) {
            margin-right: 3rem;
          }

          a,
          button {
            font-weight: bold;
            font-size: 1.8rem;

            &.primary {
              font-weight: bold;
              color: var(--text-link-color);
            }
          }
        }

        @media (max-width: 1200px) {
          .container {
            padding: 0 3rem;
          }
          .mainNavigation {
            li:not(:last-child) {
              margin-right: 2rem;
            }

            a {
              font-size: 1.3rem;
            }
          }

          .asideNavigation {
            li:not(:last-child) {
              margin-right: 2rem;
            }

            a,
            button {
              font-size: 1.8rem;
            }
          }
          .logoContainer {
            max-width: 18rem;
            margin-right: 3rem;
          }
        }

        @media (max-width: 1024px) {
          header {
            max-height: 5.5rem;
            overflow: hidden;
            box-shadow: 0 0.8rem 0.8rem rgba(0, 0, 0, 0.06);

            .burgerBtn {
              display: block;
            }

            .container {
              display: block;
              padding: 0;
              background: #f5f6f9;

              .logoContainer {
                position: sticky;
                top: 0;
                max-width: 100%;
                height: 5.5rem;
                padding: 1.9rem 1.2rem 0;
                background: #fff;
                box-shadow: 0 0.8rem 0.8rem rgba(0, 0, 0, 0.06);
              }

              .asideNavigation,
              .mainNavigation {
                max-width: 100%;

                :global(ul) {
                  display: block;

                  li {
                    margin: 0;
                    border-bottom: 0.1rem solid var(--separator-line-color);

                    a {
                      display: inline-block;
                    }

                    a,
                    button {
                      padding: 1em 2em;
                      font-size: 1.4rem;
                      font-weight: 700;
                    }
                  }
                }

                .primary {
                  width: 100%;
                  text-align: left;
                }
              }

              .notifications {
                display: inline-flex;
                margin: 0 0 0 1.3rem;
                width: 2rem;
                height: 2rem;
                background: var(--alert-color);
                border-radius: 50%;
                color: #fff;
              }
            }
          }
        }
        .link {
          cursor: pointer;
        }

        .registerHeader {
          background-color: rgba(14, 119, 239, 1);
          padding: 1em 3em;
          color: white;
          margin: 1%;
          text-align: center;
          font-family: Red Hat Display;
          font-style: normal;
          font-weight: bold;
          font-size: 1.3rem !important;
          border-radius: 2rem;
          border-collapse: separate;
          overflow: hidden;
          perspective: 1px;
        }
        .findVehiclesHeader {
          background-color: rgba(21, 42, 70, 1);
          padding: 1em 2em;
          color: white;
          margin: 1%;
          text-align: center;
          font-family: Red Hat Display;
          font-style: normal;
          font-weight: bold;
          font-size: 1.3rem !important;
          border-radius: 2rem;
          border-collapse: separate;
          overflow: hidden;
          perspective: 1px;
          display: block;
          white-space: nowrap;
        }
      `}</style>

      <style jsx>{`
        header {
          z-index: ${zIndex.Layout};
        }

        @media (max-width: 1024px) {
          header {
            z-index: ${zIndex.Modal + 1};
          }
        }
      `}</style>
    </header>
  )
})

export default Header
